// extracted by mini-css-extract-plugin
export default {"container":"home-highlight_container__7pnSo"};